"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("pageIframe").controller("pageIframeCtrl", pageIframeCtrl);

  function pageIframeCtrl($sce, CustomListsService, CustomersService, $rootScope, $timeout, $stateParams, ADMIN_URL, EXPORT_XLSX_URL, ApiService) {
    var vm = this;

    vm.ctrlName = "pageIframeCtrl";

    vm.log = debug("pages:pageIframe");

    vm.refresh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var page, token, source, _token, customer, customerName, _source;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Remplace tous les "_" par des "/" pour reconstruire le chemin
              page = $stateParams.page.replace(/_/g, "/");

              if (!(page === "excel")) {
                _context.next = 9;
                break;
              }

              _context.next = 4;
              return ApiService.getToken();

            case 4:
              token = _context.sent;
              source = EXPORT_XLSX_URL + "/?customerId=" + $rootScope.$selectedCustomerId.replace("$", "") + "&token=" + token;


              vm.source = $sce.trustAsResourceUrl(source);
              _context.next = 18;
              break;

            case 9:
              _context.next = 11;
              return ApiService.getToken();

            case 11:
              _token = _context.sent;
              _context.next = 14;
              return CustomersService.getById($rootScope.$selectedCustomerId);

            case 14:
              customer = _context.sent;
              customerName = customer ? customer.name : "???";
              _source = ADMIN_URL + "/#/" + page + "?fromDrm=true&customerId=" + $rootScope.$selectedCustomerId.replace("$", "") + "&customerName=" + customerName + "&token=" + _token;


              vm.source = $sce.trustAsResourceUrl(_source);

            case 18:

              Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

              $timeout(function () {
                iFrameResize({
                  log: true,
                  checkOrigin: false,
                  heightCalculationMethod: "bodyOffset",
                  minHeight: 900,
                  onResized: function onResized(_ref2) {
                    var type = _ref2.type;
                    return type === "mutationObserver" ? Notiflix.Loading.remove() : console.log("type", type);
                  }
                }, "#myIframe");
              }, 500);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    vm.refresh();
  }
})();